import TransferSuccessScreen from 'features/feeBasedInstantTransfer/screens/TransferSuccess/TransferSuccessScreen';

export default function InstantTransferSuccessPage() {
  return <TransferSuccessScreen />;
}
